import { AspectType } from "types/generated";
import CSVDownloadDrawerButton from "views/Account/Settings/Usage/CSVDownload/DrawerButton";
import UsageLayoutHeaderNew from "views/Account/Settings/Usage/Layout/HeaderNew";

import { WorkerUsageData } from "../types";
import { FRESHNESS_LABEL } from "../constants";
import {
  formatWorkerUsageDate,
  getWorkerUsageCycleDay,
  getWorkerUsageCycleTotalDays,
  hasWorkerUsageContract,
} from "../utils";

type UsageWorkersNewHeaderProps = {
  usage: WorkerUsageData;
};

const buildCycleCaption = (usage: WorkerUsageData) => {
  const cycleDay = getWorkerUsageCycleDay(usage);
  const cycleTotalDays = getWorkerUsageCycleTotalDays(usage);

  return `Billing cycle: ${formatWorkerUsageDate(
    usage.cycleStart,
    "d MMM"
  )} – ${formatWorkerUsageDate(
    usage.cycleEnd,
    "d MMM yyyy"
  )} · day ${cycleDay} of ${cycleTotalDays}`;
};

const UsageWorkersNewHeader = ({ usage }: UsageWorkersNewHeaderProps) => (
  <UsageLayoutHeaderNew
    title="Current period usage chart"
    tooltip={FRESHNESS_LABEL}
    caption={hasWorkerUsageContract(usage) ? buildCycleCaption(usage) : undefined}
  >
    <CSVDownloadDrawerButton aspectType={AspectType.WorkersCount} />
  </UsageLayoutHeaderNew>
);

export default UsageWorkersNewHeader;
